import { createReducer } from '@reduxjs/toolkit'

import type {
  TDerivedMetricDto,
  TDerivedMetricOptionsDto,
  TDerivedMetricPreviewDto
} from '@homepal/api-contract'

import { insertItems, removeItem, upsertItem } from 'redux/utils'

import * as actions from 'redux/actions/internal/DerivedMetrics/actions'
import * as authenticationActions from 'redux/actions/Authentication/actions'

export interface InternalDerivedMetricReducerType {
  data: Record<string, TDerivedMetricDto>
  fetched: boolean
  fetching: boolean
  options: TDerivedMetricOptionsDto
  optionsFetched: boolean
  preview: TDerivedMetricPreviewDto | null
  previewing: boolean
}

const INITIAL_STATE: InternalDerivedMetricReducerType = {
  data: {},
  fetched: false,
  fetching: false,
  options: {
    fact_tables: [],
    categories: [],
    subcategories: [],
    units: [],
    writes_texts: false,
    editable: false
  },
  optionsFetched: false,
  preview: null,
  previewing: false
}

// createReducer uses immer — cases mutate the draft directly
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload)
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getAllFailed, (state) => {
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getOptionsSuccess, (state, action) => {
      state.options = action.payload
      state.optionsFetched = true
    })
    .addCase(actions.getOptionsFailed, (state) => {
      state.optionsFetched = true
    })
    .addCase(actions.preview, (state) => {
      state.previewing = true
    })
    .addCase(actions.previewSuccess, (state, action) => {
      state.preview = action.payload
      state.previewing = false
    })
    .addCase(actions.previewFailed, (state) => {
      state.preview = null
      state.previewing = false
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.destroySuccess, (state, action) => {
      state.data = removeItem(state.data, action.payload)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
